module.exports = __webpack_public_path__ + "img/bg_function04_3_m.97c845c4.png";